 
import axios, { AxiosResponse } from 'axios';
import Api from './Api';
import ApiEnvironment from '../constants/ApiEnvironment';
import { loaderRef } from '@/components/ui/loader';
import { toast } from 'sonner';
import LocalStorage from '@/utilities/LocalStorage';
import cloneDeepWith from 'lodash.clonedeepwith';
import { authLogoutRef } from '@/context/auth/AuthContext';

function deepTrimWithLodash(obj: any): any {
  return cloneDeepWith(obj, value => {
    if (typeof value === 'string') {
      return value.trim();
    }
    return undefined;
  });
}

const methodsToTrim: string[] = ['post', 'put', 'patch'];

export interface CustomAxiosResponse<T = any> extends AxiosResponse<T> {
  data: T;
  error?: boolean;
  message?: string | null;
}
const RequestService = axios.create({
  baseURL: Api.getBaseUrl(ApiEnvironment.Services.userService),
});

RequestService.defaults.headers.head['Content-Type'] = 'application/json';
RequestService.defaults.validateStatus = status => status < 500;

export function setAxiosAuthToken(token: string | null) {
  if (token) {
    RequestService.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete RequestService.defaults.headers.common.Authorization;
  }
}

setAxiosAuthToken(LocalStorage.token());

declare module 'axios' {
  export interface AxiosRequestConfig {
    showLoader?: boolean;
  }
}

RequestService.interceptors.response.use(
  response => {
    const token = LocalStorage.token();
    if (response.status === 401) {
      if (token) {
        toast.error("Lütfen tekrar giriş yapınız.");
        setTimeout(() => {
          authLogoutRef.current?.logout();
        }, 2000);
      }
    }
    if (response.config.showLoader !== false) {
      loaderRef.current!.decLoader();
    }
    return ({
      ...response,
      message: response.data.message,
      error: response.data.error,
      data: response.data.data || response.data.Result,
      statusCode: response.data.statusCode,
    })
  },
  error => {
    console.log('Error', error);
    error?.response?.data?.message && toast.error(error?.response?.data?.message)
    if (error.config?.showLoader !== false) {
      loaderRef.current!.decLoader();
    }
    return Promise.reject(error);
  },
);

RequestService.interceptors.request.use(
  request => {
    if (request.showLoader !== false) {
      loaderRef.current!.incLoader();
    }

    if (request.method && methodsToTrim.includes(request.method) && request.data) {
      if (request.data instanceof FormData) {
        const newFormData = new FormData();

        for (const [key, value] of request.data.entries()) {
          
          if (typeof value === 'string') {
            newFormData.append(key, value.trim());
          } else {
            newFormData.append(key, value);
          }
        }
        
        request.data = newFormData;

      } else {
        request.data = deepTrimWithLodash(request.data);
      }
    }

    return request
  },
  error => {
    if (error.config?.showLoader !== false) {
      loaderRef.current!.decLoader();
    }
    return Promise.reject(error);
  },
);

export default RequestService;
